const TWO_HOURS_MS = 2 * 60 * 60 * 1000
const LIKED_KEY = 'cf-liked-articles'

export function getAutoBoost(startIso?: string): number {
  if (!startIso) return 0
  const start = new Date(startIso).getTime()
  if (!Number.isFinite(start) || start <= 0) return 0
  const elapsed = Date.now() - start
  if (elapsed <= 0) return 0
  return Math.floor(elapsed / TWO_HOURS_MS)
}

export function getDisplayedLikes(realLikes: number | undefined, startIso?: string): number {
  return Math.max(0, (realLikes || 0) + getAutoBoost(startIso))
}

export function getDisplayedShares(realShares: number | undefined, startIso?: string): number {
  return Math.max(0, (realShares || 0) + getAutoBoost(startIso))
}

export function formatCount(n: number): string {
  if (n >= 1_000_000) {
    const v = n / 1_000_000
    return `${v >= 10 ? Math.round(v) : v.toFixed(1).replace('.0', '')}M`
  }
  if (n >= 1000) {
    const v = n / 1000
    return `${v >= 10 ? Math.round(v) : v.toFixed(1).replace('.0', '')} mil`
  }
  return String(n)
}

export function getLikedIds(): string[] {
  try {
    const raw = localStorage.getItem(LIKED_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string') : []
  } catch {
    return []
  }
}

export function setArticleLiked(articleId: string, liked: boolean): void {
  const ids = new Set(getLikedIds())
  if (liked) ids.add(articleId)
  else ids.delete(articleId)
  localStorage.setItem(LIKED_KEY, JSON.stringify([...ids]))
}

export function hasLikedArticle(articleId: string): boolean {
  return getLikedIds().includes(articleId)
}
